import * as React from 'react';
import { Recipe } from '@src/firebase/types';
import { ViewDivider } from '@src/routes/recipes/components/ViewDivider';
import { ViewStep } from '@src/routes/recipes/components/ViewStep';

interface ViewStepsProps {
  className?: string;
  recipe: Recipe;
}

/**
 * @name ViewSteps
 * @description tbd...
 */
const ViewSteps: React.FC<ViewStepsProps> = (props) => {
  const { className, recipe } = props;

  // Hooks

  // Setup
  const numSteps = `${recipe.steps.length} Steps`;

  // Styles

  // Handlers

  // Markup

  // Life Cycle

  // Short Circuit

  return (
    <div className={className}>
      <ViewDivider title={numSteps} />
      {recipe.steps.map((step, index) => (
        <ViewStep key={index} recipe={recipe} step={step} stepIndex={index} />
      ))}
    </div>
  );
};

export { ViewSteps };
export type { ViewStepsProps };
